import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Button, Typography, Box } from '@material-ui/core';
import CreateAccount from './CreateAccount';
// import InOfficeReservations from '../assets/images/InOfficeReservation.png';
// import GroupReservations from '../assets/images/GroupReservation.png';
// import OnlineCustomerReservation from '../assets/images/OnlineCustomerReservation.png'
// import BusinessRuleConfiguration from '../assets/images/BusinesRuleRegulations.png'
// import UtilityBilling from '../assets/images/UtilityBilling.png'
// import MeterReading from '../assets/images/MeterReading.png'
// import GanttChart from '../assets/images/GanttChart.png'
// import Reports from '../assets/images/Reports.png'
// import PaymentReporting from '../assets/images/PaymentReporting.png'
// import CustomEmailTemplates from '../assets/images/CustomEmailTemplates.png'
// import MultipleUserAccounts from '../assets/images/MultipleUsers.png'
// import POS from '../assets/images/POS.png'

import InOfficeReservations from '../assets/images/In-Office-Reservation.svg';
import GroupReservations from '../assets/images/Group-Reservations.svg';
import OnlineCustomerReservation from '../assets/images/OnlineCustomerReservation.png'
import BusinessRuleConfiguration from '../assets/images/Business-rule-configuration.svg'
import UtilityBilling from '../assets/images/utility-billing.svg'
import MeterReading from '../assets/images/MeterReading.png'
import GanttChart from '../assets/images/Camp-site-availability.svg'
import Reports from '../assets/images/Reservation-list.svg'
import PaymentReporting from '../assets/images/Payment-reporting.svg'
import CustomEmailTemplates from '../assets/images/Email-templates.png'
import MultipleUserAccounts from '../assets/images/multiple-user.png'
import POS from '../assets/images/payment-pos.png'

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import AddIcon from '@mui/icons-material/Add';
import MonthlyQuarterlyBackground from '../assets/images/PricingBackground.svg'
import YearlyBackground from '../assets/images/YearlyBackground.svg'
import "@fontsource/source-sans-pro";
import { InputBase } from '@mui/material';
import './style.css'

const useStyles = theme => ({
    root: {
        position: 'relative',
        paddingTop: '0',
        padding: '3%',
    },
    button: {
        marginTop: theme.spacing(2),
        width: '150px',
        height: '50px',
        backgroundColor: '#fff',
        color: '#000000',
        fontSize: '20px',
        fontWeight: 'bold',
        fontFamily: 'Source Sans Pro',
        border: '1px solid black',
        "&:hover": {
            backgroundColor: '#fff',
            color: '#000000'
        },
    },
    demoButton: {
        marginTop: theme.spacing(5),
        width: '150px',
        fontFamily: 'Source Sans Pro',
        backgroundColor: '#1c9571',
        fontSize: '15px',
        fontWeight: 'bold',
        "&:hover": {
            backgroundColor: '#1c9571',
            color: '#FFFFFF'
        },
    },
    textfield: {
        margin: theme.spacing(1),
        width: '50px',
        marginLeft: '20px',
        borderBottom: `1px solid #1DB771`
    },
});


class Pricing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            createAccount: false,
            noOfSites: '1',

            //monthly
            monthly: '',

            //quarterly
            quarterlyPerMonth: '',
            quarterlyTotal: '',

            //yearly
            yearltPerMonth: '',
            yearlyTotal: '',

            //accordian
            currentExpanded: false
        }
    }

    async componentDidMount() {
        this.calculateSubscriptionPrice()
    }

    handleChange = (event) => {
        this.setState({
            formValid: false,
            noOfSites: event.target.value,
        }, () => {
            this.calculateSubscriptionPrice();
        });

    };

    handleAccordianChange  = (panel) => (event, isExpanded) => {
        this.setState({
            currentExpanded: (isExpanded ? panel : false)
        })
    };

    calculateSubscriptionPrice = async () => {
        let totalSites = parseInt(this.state.noOfSites)
        if (totalSites > 50) {
            console.log("totol sites: ", totalSites)
            const rate = 0.40
            //yearly
            let total = rate * totalSites
            let yearlyMonthrate = total - (total * 0.1)
            let yearly = yearlyMonthrate * 12
            console.log("yearly per month :  ", parseFloat(yearlyMonthrate).toFixed(2))
            console.log("yearly :  ", parseFloat(yearly).toFixed(2))

            //quarterly
            let quarterlyMonthRate = total - (total * 0.05)
            let quarterly = quarterlyMonthRate * 3
            console.log("quaterly per month:  ", parseFloat(quarterlyMonthRate).toFixed(2))
            console.log("quaterly total :  ", parseFloat(quarterly).toFixed(2))

            //monthly
            let monthly = total
            console.log("monthly total :  ", parseFloat(monthly).toFixed(2))

            this.setState({
                // yearly
                yearltPerMonth: parseFloat(yearlyMonthrate).toFixed(2),
                yearlyTotal: parseFloat(yearly).toFixed(2),

                //quarterly
                quarterlyPerMonth: parseFloat(quarterlyMonthRate).toFixed(2),
                quarterlyTotal: parseFloat(quarterly).toFixed(2),

                //monthly
                monthly: parseFloat(monthly).toFixed(2),
            })
        } else {
            const rate = 20.00

            //yearly
            let yearlyMonthrate = rate - (rate * 0.1)
            let yearly = yearlyMonthrate * 12
            console.log("yearly per month :  ", parseFloat(yearlyMonthrate).toFixed(2))
            console.log("yearly :  ", parseFloat(yearly).toFixed(2))

            //quarterly
            let quarterlyMonthRate = rate - (rate * 0.05)
            let quarterly = quarterlyMonthRate * 3
            console.log("quaterly per month:  ", parseFloat(quarterlyMonthRate).toFixed(2))
            console.log("quaterly total :  ", parseFloat(quarterly).toFixed(2))

            this.setState({
                // yearly
                yearltPerMonth: parseFloat(yearlyMonthrate).toFixed(2),
                yearlyTotal: parseFloat(yearly).toFixed(2),

                //quarterly
                quarterlyPerMonth: parseFloat(quarterlyMonthRate).toFixed(2),
                quarterlyTotal: parseFloat(quarterly).toFixed(2),

                //monthly
                monthly: parseFloat(rate).toFixed(2),
            })
        }
    }

    viewDemo = async () => {
        window.open("https://opencampground.com/demo/", "_black")
    };

    render() {
        const { classes } = this.props;
        return (
            <>
                {this.state.createAccount
                    ? <CreateAccount />
                    : <Grid container className={classes.root}>
                        {/* simple transparent Pricing */}
                        {/* <Grid container style={{ justifyContent: 'center' }}>
                            <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#000000', fontSize: '3.4em', fontWeight: 'bold', marginTop: '2%' }} >
                                Simple
                            </Typography>
                            <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#1fb771', fontSize: '3.4em', fontWeight: 'bold', marginTop: '2%', marginLeft: '10px' }} >
                                Transparent Pricing
                            </Typography>
                        </Grid> */}

                        {/* number of sites */}
                        <Grid container style={{ justifyContent: 'center' }}>
                            <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#1fb771', fontSize: '1.5rem', fontWeight: '600' }} >
                                Enter number of sites
                            </Typography>
                            <InputBase id="noOfSites" required type="number" variant="standard"
                                className={classes.textfield} onChange={this.handleChange} style={{ marginLeft: '20px' }} />

                        </Grid>

                        {/* monthly yarly quarterly box */}
                        <Grid container spacing={5} style={{ padding: '3%', justifyContent: 'center' }}>
                            {/* Monthly */}
                            <Grid item>
                                <Box style={{ border: '1px solid black', boxShadow: '0 0 10px gray', backgroundImage: `url(${MonthlyQuarterlyBackground})`, backgroundSize: 'cover', borderRadius: '20px', maxWidth: '500rem' }}>
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#353535', fontSize: '3.5rem', fontWeight: '600' }} >
                                        Monthly
                                    </Typography>
                                    <hr
                                        style={{
                                            marginLeft: '20px',
                                            background: "#000",
                                            height: "3px",
                                            border: "none",
                                            marginRight: '20px'
                                        }}
                                    />
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#353535', fontSize: '4.8rem', fontWeight: '600' }} >
                                        ${this.state.monthly}
                                    </Typography>
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#353535', fontSize: '1.1rem', fontWeight: '600', marginTop: '-20px' }} >
                                        Monthly
                                    </Typography>
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#353535', fontSize: '1rem', fontWeight: '500' }} >
                                        Total Billed ${this.state.monthly}
                                    </Typography><br />
                                    <Button variant="contained" color="primary" className={classes.button} onClick={() => { this.setState({ createAccount: true }) }} >BUY NOW </Button>
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#353535', fontSize: '1.2rem', fontWeight: '700', marginBottom: '20px', padding: '1rem 3rem 0 3em', }} >
                                        No Credit Card Required
                                    </Typography>
                                    <br /><br /><br />
                                </Box>
                            </Grid>

                            {/* Yearly */}
                            <Grid item>
                                <Box style={{ border: '1px solid black', boxShadow: '0 0 10px gray', backgroundImage: `url(${YearlyBackground})`, backgroundSize: 'cover', borderRadius: '20px' }}>
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#ffffff', fontSize: '3.5rem', fontWeight: '600' }} >
                                        Yearly
                                    </Typography>
                                    <hr
                                        style={{
                                            marginLeft: '20px',
                                            background: "#fff",
                                            height: "3px",
                                            border: "none",
                                            marginRight: '20px'
                                        }}
                                    />
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#ffffff', fontSize: '4.8rem', fontWeight: '600' }} >
                                        ${this.state.yearltPerMonth}
                                    </Typography>
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#ffffff', fontSize: '1.1rem', fontWeight: '600', marginTop: '-20px' }} >
                                        Monthly
                                    </Typography>
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#ffffff', fontSize: '1rem', fontWeight: '500' }} >
                                        Total Billed ${this.state.yearlyTotal}
                                    </Typography><br />
                                    <Button variant="contained" color="primary" className={classes.button} onClick={() => { this.setState({ createAccount: true }) }} >BUY NOW </Button>
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#ffffff', fontSize: '1.2rem', fontWeight: '700', padding: '1rem 3rem 0 3em', }} >
                                        No Credit Card Required
                                    </Typography>
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#ffffff', fontSize: '1.5rem', marginBottom: '30px' }} >
                                        Save 10%
                                    </Typography>
                                </Box>
                            </Grid>

                            {/* Quarterly */}
                            <Grid item style={{}}>
                                <Box style={{ border: '1px solid black', boxShadow: '0 0 10px gray', backgroundImage: `url(${MonthlyQuarterlyBackground})`, backgroundSize: 'cover', borderRadius: '20px' }}>
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#353535', fontSize: '3.5rem', fontWeight: '600' }} >
                                        Quarterly
                                    </Typography>
                                    <hr
                                        style={{
                                            marginLeft: '20px',
                                            background: "#000",
                                            height: "3px",
                                            border: "none",
                                            marginRight: '20px'
                                        }}
                                    />
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#353535', fontSize: '4.8rem', fontWeight: '600' }} >
                                        ${this.state.quarterlyPerMonth}
                                    </Typography>
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#353535', fontSize: '1.1rem', fontWeight: '600', marginTop: '-20px' }} >
                                        Monthly
                                    </Typography>
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#353535', fontSize: '1rem', fontWeight: '500' }} >
                                        Total Billed ${this.state.quarterlyTotal}
                                    </Typography><br />
                                    <Button variant="contained" color="primary" className={classes.button} onClick={() => { this.setState({ createAccount: true }) }} >BUY NOW </Button>
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#353535', fontSize: '1.2rem', fontWeight: '700', padding: '1rem 3rem 0 3em', }} >
                                        No Credit Card Required
                                    </Typography>
                                    <br /><br /><br /><br />
                                </Box>
                            </Grid>
                        </Grid>

                        {/* Key features typo */}
                        {/* <Grid container style={{ justifyContent: 'center' }}>
                            <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#000000', fontSize: '2.6rem', fontWeight: '700', marginTop: '2%' }} >
                                Key
                            </Typography>
                            <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#1fb771', fontSize: '2.6rem', fontWeight: '700', marginTop: '2%', marginLeft: '10px' }} >
                                Features
                            </Typography>
                        </Grid> */}

                        {/* Key Features */}
                        {/* <Grid container spacing={5}
                            style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(20%), max(33.33%)))', padding: '3%' }}
                        >
                            <Grid item>
                                <Box>
                                    <img src={InOfficeReservations} alt="In office Reservation" style={{ height: '5em', width: '5em' }} />
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#000', fontSize: '1.2rem', fontWeight: '700' }}>
                                        In Office Reservation
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box>
                                    <img src={GroupReservations} alt="Group Reservation" style={{ height: '5em', width: '5em' }} />
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#000', fontSize: '1.2rem', fontWeight: '700' }} >
                                        Group Reservation
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box>
                                    <img src={OnlineCustomerReservation} alt="Online Customer Reservation" style={{ height: '5em', width: '5em' }} />
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#000', fontSize: '1.2rem', fontWeight: '700' }} >
                                        Online Customer Reservation
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box>
                                    <img src={BusinessRuleConfiguration} alt="Business Rule Configuration" style={{ height: '5em', width: '5em' }} />
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#000', fontSize: '1.2rem', fontWeight: '700' }} >
                                        Business Rule Configuration
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box>
                                    <img src={UtilityBilling} alt="Utility Billing" style={{ height: '5em', width: '5em' }} />
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#000', fontSize: '1.2rem', fontWeight: '700' }} >
                                        Utility Billing
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box>
                                    <img src={MeterReading} alt="Meter Reading" style={{ height: '5em', width: '5em' }} />
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#000', fontSize: '1.2rem', fontWeight: '700' }} >
                                        Meter Reading
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box>
                                    <img src={GanttChart} alt="Site Availability Gantt Chart" style={{ height: '5em', width: '5em' }} />
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#000', fontSize: '1.2rem', fontWeight: '700' }} >
                                        Site Availability Gantt Chart
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box>
                                    <img src={Reports} alt="Reservation and Campoer Reports" style={{ height: '5em', width: '5em' }} />
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#000', fontSize: '1.2rem', fontWeight: '700' }} >
                                        Reservation and Campoer Reports
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box>
                                    <img src={PaymentReporting} alt="Payment Reporting" style={{ height: '5em', width: '5em' }} />
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#000', fontSize: '1.2rem', fontWeight: '700' }} >
                                        Payment Reporting
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box>
                                    <img src={CustomEmailTemplates} alt="Custom Email Templates" style={{ height: '5em', width: '5em' }} />
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#000', fontSize: '1.2rem', fontWeight: '700' }} >
                                        Custom Email Templates
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box>
                                    <img src={MultipleUserAccounts} alt="Multiple User Accounts" style={{ height: '5em', width: '5em' }} />
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#000', fontSize: '1.2rem', fontWeight: '700' }} >
                                        Multiple User Accounts
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box>
                                    <img src={POS} alt="POS Integrations with Clover and Ingenico" style={{ height: '5em', width: '5em' }} />
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#000', fontSize: '1.2rem', fontWeight: '700' }} >
                                        POS Integrations with Clover and Ingenico
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid> */}

                        {/* Demo */}
                        {/* <Grid container style={{ justifyContent: 'center' }}>
                            <Box className="demoBox">
                                <Grid container style={{ justifyContent: 'center' }}>
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#000000', fontSize: '3rem', fontWeight: 'bold', marginTop: '2%' }} >
                                        Try OpenCampground
                                    </Typography>
                                    <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#1fb771', fontSize: '3rem', fontWeight: 'bold', marginTop: '2%', marginLeft: '10px' }} >
                                        Risk Free!
                                    </Typography>
                                </Grid>
                                <Button variant="contained" color="primary" className={classes.demoButton} onClick={this.viewDemo} >View a Demo </Button>
                            </Box>
                        </Grid> */}

                        {/* FaQ Typo */}
                        {/* <Grid container style={{ justifyContent: 'center', margin: '3rem 0 2rem 0' }}>
                            <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#000000', fontSize: '2.6rem', fontWeight: '700', marginTop: '2%' }} >
                                Frequently Asked
                            </Typography>
                            <Typography variant="subtitle1" style={{ fontFamily: 'Source Sans Pro', color: '#1fb771', fontSize: '2.6rem', fontWeight: '700', marginTop: '2%', marginLeft: '10px' }} >
                                Questions
                            </Typography>
                        </Grid> */}

                        {/* FaQ */}
                        {/* <Grid container style={{ justifyContent: 'center' }}>
                            <Box style={{ margin: '2rem 5rem 2rem 5rem' }}>
                                <Accordion style={{ maxWidth: '450px',boxShadow:'none' }} expanded={this.state.currentExpanded === 'panel1'} onChange={this.handleAccordianChange('panel1')}>
                                    <AccordionSummary
                                        expandIcon={<AddIcon />}
                                    >
                                        <Typography align="left" style={{ fontFamily: 'Source Sans Pro', fontSize: '1rem', fontWeight: '400', color: '#000000' }}>Do I need to download and install any software to use OpenCampground?</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography align="left" style={{ color: '#6a6969', fontFamily: 'Source Sans Pro', fontSize: '1rem', fontWeight: '300' }}>
                                            No, OpenCampground is a cloud based software, which means you can access
                                            it directly through a web browser without the need to download or install
                                            anything on your device.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion style={{ maxWidth: '450px',boxShadow:'none' }} expanded={this.state.currentExpanded === 'panel2'} onChange={this.handleAccordianChange('panel2')}>
                                    <AccordionSummary
                                        expandIcon={<AddIcon />}
                                    >
                                        <Typography align="left" style={{ fontFamily: 'Source Sans Pro', fontSize: '1rem', fontWeight: '400', color: '#000000' }}>What are the payment options for OpenCampground's subscription?</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography align="left" style={{ color: '#6a6969', fontFamily: 'Source Sans Pro', fontSize: '1rem', fontWeight: '300' }}>
                                            We offer multiple payment options for your convenience. You can pay your subscription
                                            using all major credit cards, such as Visa, MasterCard, Discover, and American Express,
                                            and Bank Accounts.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion style={{ maxWidth: '450px',boxShadow:'none' }} expanded={this.state.currentExpanded === 'panel3'} onChange={this.handleAccordianChange('panel3')}>
                                    <AccordionSummary
                                        expandIcon={<AddIcon />}
                                    >
                                        <Typography align="left" style={{ fontFamily: 'Source Sans Pro', fontSize: '1rem', fontWeight: '400', color: '#000000' }}>Am I Required To Use OpenCampgrounds In-House Merchant Services</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography align="left" style={{ color: '#6a6969', fontFamily: 'Source Sans Pro', fontSize: '1rem', fontWeight: '300' }}>
                                            No. Currently, we have integrations with Paypal, Card Connect, and CardKnox.
                                            However, the features we provide such as a Resident Payment Portal, Web
                                            Reservation System, Next Day funding, and special rates can only be used by
                                            our in-house merchant services.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </Box>

                            <Box style={{ margin: '2rem 5rem 2rem 2rem' }}>
                                <Accordion style={{ maxWidth: '450px',boxShadow:'none' }} expanded={this.state.currentExpanded === 'panel4'} onChange={this.handleAccordianChange('panel4')}>
                                    <AccordionSummary
                                        expandIcon={<AddIcon />}
                                    >
                                        <Typography align="left" style={{ fontFamily: 'Source Sans Pro', fontSize: '1rem', fontWeight: '400', color: '#000000' }}>Can I Upload My Existing Customer List To OpenCampground?</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography align="left" style={{ color: '#6a6969', fontFamily: 'Source Sans Pro', fontSize: '1rem', fontWeight: '300' }}>
                                            Yes, we offer a feature within OpenCampground that allows you to
                                            upload your customer list. However, if you are uncomfortable performing
                                            this task yourself, our engineers can upload the file for you. We do
                                            charge a ontime $199 for this task.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion style={{ maxWidth: '450px',boxShadow:'none' }} expanded={this.state.currentExpanded === 'panel5'} onChange={this.handleAccordianChange('panel5')}>
                                    <AccordionSummary
                                        expandIcon={<AddIcon />}
                                    >
                                        <Typography align="left" style={{ fontFamily: 'Source Sans Pro', fontSize: '1rem', fontWeight: '400', color: '#000000' }}>Do You Provide Support?</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography align="left" style={{ color: '#6a6969', fontFamily: 'Source Sans Pro', fontSize: '1rem', fontWeight: '300' }}>
                                            Many of our customers have found that OpenCampground
                                            is simple to use, and they’ve been able to self-serve.
                                            OpenCampground provides all customers with a Demo site
                                            that mirrors our Live site. This allows you to learn
                                            the software as you go, and play around with settings
                                            to see how it will affect your business operations.
                                            However, if you need further assistance, you can at
                                            any time reach out to our helpful support team.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion style={{ maxWidth: '450px',boxShadow:'none' }} expanded={this.state.currentExpanded === 'panel6'} onChange={this.handleAccordianChange('panel6')}>
                                    <AccordionSummary
                                        expandIcon={<AddIcon />}
                                    >
                                        <Typography align="left" style={{ fontFamily: 'Source Sans Pro', fontSize: '1rem', fontWeight: '400', color: '#000000' }}>How Can I Pay My Monthly Subscription?</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography align="left" style={{ color: '#6a6969', fontFamily: 'Source Sans Pro', fontSize: '1rem', fontWeight: '300' }}>
                                            Customers can pay their monthly subscription using a
                                            credit or debit card or by linking their bank account
                                            to a secured payment portal.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion style={{ maxWidth: '450px',boxShadow:'none' }} expanded={this.state.currentExpanded === 'panel7'} onChange={this.handleAccordianChange('panel7')}>
                                    <AccordionSummary
                                        expandIcon={<AddIcon />}
                                    >
                                        <Typography align="left" style={{ fontFamily: 'Source Sans Pro', fontSize: '1rem', fontWeight: '400', color: '#000000' }}>Can I Use Autopayments For My Monthly Subscription?</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography align="left" style={{ color: '#6a6969', fontFamily: 'Source Sans Pro', fontSize: '1rem', fontWeight: '300' }}>
                                            Absolutely! We offer the convenience of auto payments for your monthly subscription.
                                            This means your payment will be automatically deducted from your chosen payment method on your billing date.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </Box>
                        </Grid> */}
                    </Grid>
                }
            </>
        );
    };
};

export default withStyles(useStyles)(Pricing);
